import React, { useEffect, useState } from 'react';
import { getSpiderWeb, getSpiderWebAccess } from '../../../store/entities/professionalReport/thunks';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useCurrentLanguage from '../../../hooks/user/useCurrentLanguage';
import HierarchyTree from '../../OtherProducts/Spiderweb/SpiderwebMap/components/HierarchyTree';
import { Button, Col, Layout, message, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';
import useUserClaims from '../../../hooks/user/useUserClaims';
import CompanyDataCard from '../../../components/reusable/CompanyDataCard';
import { ReactComponent as SpiderwebIcon } from 'assets/img/icons/spiderweb.svg';
import useIsUiHidden from '../../../hooks/dom/useIsUiHidden';

const SpiderWeb = () => {
  const isUiHidden = useIsUiHidden();
  const [activeOrder, setActiveOrder] = useState(false);
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const lang = useCurrentLanguage();
  const { t } = useTranslation();

  const { orderId, spiderweb, spiderwebPending, orderDetails } = useSelector(state => state.professionalReport);
  const handleSpiderRequest = async () => {
    const response = await dispatch(getSpiderWebAccess({ orderId: orderDetails?.id }));

    if (getSpiderWebAccess.fulfilled.match(response)) {
      setActiveOrder(true);
    } else {
      message.error(t('feedback.modal.errorMsg'), 5);
    }
  };

  useEffect(() => {
    if ((orderId && orderDetails && !spiderweb) || (orderId && orderDetails && spiderweb?.lang !== lang)) {
      const searchParams = {
        companyCode: companyId,
        companyName: orderDetails?.companyTitle,
        personCode: '',
        personName: '',
        country: 'LT',
        relationTypes: [255],
        spiderWebUsageType: 'ProfessionalReport',
      };
      dispatch(getSpiderWeb({ orderId: orderDetails?.id, searchParams }));
    }
  }, [lang, orderDetails]);

  const permissions = useUserClaims();
  const allowedSpider = permissions && permissions.some(item => item.key === '/product/spiderweb/' && item.value);

  if (spiderwebPending || isUiHidden) return null;

  const IndividualBtn = ({ allowedSpider }) => {
    return (
      <Button
        onClick={() =>
          localStorage.setItem(
            'spiderParams',
            JSON.stringify({
              companyCode: companyId,
              companyName: orderDetails?.companyTitle,
              personCode: '',
              personName: '',
              country: 'LT',
              relationTypes: [255],
              spiderWebUsageType: 1,
            })
          )
        }
        icon={<SearchOutlined style={{ color: '#c40f11' }} />}
      >
        {allowedSpider
          ? t('professionalReport.spiderweb.link.button')
          : t('professionalReport.spiderweb.notAllow.button')}
      </Button>
    );
  };

  return (
    <CompanyDataCard
      icon={<SpiderwebIcon />}
      title={t('professionalReport.spiderweb.title')}
      style={{ background: '#f4f4f4' }}
    >
      <div className="buy-report-wrapper">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            {!activeOrder &&
              (allowedSpider ? (
                <a href={'/spiderweb'} target="_blank" rel="noopener noreferrer" style={{ position: 'absolute' }}>
                  <IndividualBtn allowedSpider={allowedSpider} />
                </a>
              ) : (
                <div style={{ position: 'absolute' }} onClick={handleSpiderRequest}>
                  <IndividualBtn allowedSpider={allowedSpider} />
                </div>
              ))}
            {activeOrder && (
              <div className="buy-report-overlay">
                <Row>
                  <Col xs={16} sm={16} md={16} lg={18} xl={19} xxl={20} className="buy-report-overlay-title-short">
                    {t('professionalReport.spiderweb.order.success')}
                  </Col>
                </Row>
              </div>
            )}
            <Layout height={640} className={`${activeOrder ? 'content-blur ' : ''}spider-container`}>
              {spiderweb && <HierarchyTree data={spiderweb} profReport />}
            </Layout>
          </Col>
        </Row>
      </div>
    </CompanyDataCard>
  );
};

export default SpiderWeb;
